import React from 'react';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import MetaTags from 'src/components/meta-tags';
import { FullPageLoader } from 'shared/components';
import useCart from 'shared/hooks/use-cart';
import { useKioskIdentityVisibility } from 'src/hooks/use-kiosk-identity-visibility';
import { useKioskDisplayName } from 'src/hooks/use-kiosk-display-name';
import {
  ButtonContainer,
  KioskIdentityLabel,
  KioskIdentityTapRegion,
  LockScreenContainer,
  Logo,
  LogoContainer,
  StartShoppingButton,
} from './lock-screen.styles';

export const LockScreen = (): JSX.Element | null => {
  const {
    dispensary: { cName, logoImage, name },
    loading,
  } = useDispensary();
  const Cart = useCart();
  const { isHidden: isKioskIdentityHidden, registerTap } = useKioskIdentityVisibility();
  const kioskDisplayName = useKioskDisplayName(Cart?.originKioskId ?? null);

  if (loading) {
    return <FullPageLoader />;
  }

  const dispensaryUrl = `/kiosks/${String(cName)}`;

  return (
    <>
      <MetaTags />
      <LockScreenContainer>
        {kioskDisplayName &&
          (isKioskIdentityHidden ? (
            <KioskIdentityTapRegion data-testid='kiosk-identity-restore-region' onClick={registerTap} />
          ) : (
            <KioskIdentityLabel data-testid='kiosk-identity-indicator' onClick={registerTap}>
              Kiosk: {kioskDisplayName}
            </KioskIdentityLabel>
          ))}
        {logoImage && (
          <LogoContainer>
            <div>
              <Logo
                src={logoImage}
                disableSrcSet
                htmlAttributes={{ alt: name }}
                imgixParams={{
                  h: 400,
                  w: 400,
                }}
              />
            </div>
          </LogoContainer>
        )}

        <ButtonContainer>
          <StartShoppingButton href={dispensaryUrl}>Tap to Start Shopping</StartShoppingButton>
        </ButtonContainer>
      </LockScreenContainer>
    </>
  );
};
